export const DEFAULT_DECIMALS = 18;
export const NATIVE_CURRENCY_DECIMALS = 18;

export const PRECISION_DECIMALS = 36;
export const PRECISION_FACTOR = 10n ** BigInt(PRECISION_DECIMALS);

/**
 * Rounding types are away from zero
 * - half-up: away from zero
 * - up: away from zero
 * - down: toward zero
 */
export type RoundingType = "half-up" | "up" | "down";
